import { render } from "./contrats_overview.vue?vue&type=template&id=1d5dd1e1"
import script from "./contrats_overview.vue?vue&type=script&lang=ts"
export * from "./contrats_overview.vue?vue&type=script&lang=ts"
script.render = render

export default script